import queryKeys from '@/constants/queryKeys';
import { getUSStates } from '@/services/api/requests/meta';
import { useQuery } from '@tanstack/react-query';

const useUSStates = () => {
  const { isLoading, data, isError, error, isRefetching, refetch } = useQuery({
    queryKey: [queryKeys.meta.USStates],
    staleTime: 0,
    queryFn: async () => {
      const response = await getUSStates();

      return response;
    },
  });

  return { isLoading, data, isError, error, isRefetching, refetch };
};

export default useUSStates;
